import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProjectCards } from "../../../../components";
import NoData from "../../../../components/NoData";
import { infiniteDataProcess, loadMore } from "../../../../plugins/utils";
import DetailModal from "../DetailModal";
import styles from "./style.module.scss";

const MyProject = ({
  data,
  showReturn,
  showDivider,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  showFooterDivider,
  style,
}) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [targetData, setTargetData] = useState();
  const [localData, setLocalData] = useState([]);

  const handleClickViewDetail = (target) => {
    setOpenModal(true);
    setTargetData(target);
  };

  useEffect(() => {
    if (data) {
      infiniteDataProcess(data, setLocalData);
    }
  }, [data]);

  useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <div className={styles.project}>
      {localData.length > 0 ? (
        <ProjectCards
          data={localData}
          alreadyBuy={true}
          showReturn={showReturn}
          showDivider={showDivider}
          showFooterDivider={showFooterDivider}
          clickDetail={handleClickViewDetail}
          loadMore={() => loadMore(isFetchingNextPage, localData, fetchNextPage)}
          hasMore={hasNextPage && localData.length > 0}
          style={style}
        />
      ) : (
        <NoData title={t("normal.noData")} />
      )}
      <DetailModal targetData={targetData} open={openModal} setOpen={setOpenModal} />
    </div>
  );
};

export default MyProject;
